<template>
  <div class="main">
    <h1 :style="{ display: page.pageTitle ? 'block' : 'none' }">{{ page.pageTitle }}</h1>
    <div class="body">

      <template v-for="(p, key) in page.links">
        <!-- <p style="text-align: center; height: 0.6rem" :key="key" v-if="p.key == 1">
          {{ p.value }}
        </p> -->
        <div :key="'1-' + key" class="link" v-if="
          p.key == 1 ||
          (page.links.length > key + 1 && page.links[key + 1].key == 6)
        ">
          <span class="back">
            <span v-show="p.value" class="font-back-color">{{ page.applet.judgeModel == 1 && p.value == "或" ? '' : p.value
              }}</span>
          </span>
        </div>
        <div :key="'2-' + key" class="link" v-else-if="
          (p.key == 2 && (judgeResult == '相符' || judgeResult == 'xxxx')) ||
          (page.links.length > key + 1 &&
            page.links[key + 1].key == 6 &&
            judgeResult == '不相符')
        ">
          <span class="back"><span class="font-back-color">{{ p.label
          }}<a @click="goTo(p.value)" type="primary" disabled v-html="p.text"></a></span></span>
        </div>
        <div :key="'3-' + key" v-else-if="p.key == 3">
          <img :src="p.value" style="width: 100%" alt="" />
        </div>
        <div :key="'4-' + key" v-else-if="p.key == 4">
          <video controls autoplay volume="0.2" width="100%">
            <source :src="p.value" type="video/mp4" />
          </video>
        </div>
        <!-- <Photograph
          :key="key"
          :applet="page.applet"
          v-else-if="p.key == 5"
        ></Photograph> -->

        <Main :key="'5-' + key" :applet="page.applet" :page="p" :links="page.links" :pageInfo="page"
          v-else-if="p.key == 5 || p.key == 11"></Main>
        <Result :key="'6-' + key" :link="p" :applet="page.applet" :judge="judgeResult" v-else-if="p.key == 6"></Result>
        <XWResult :key="'14-' + key" :link="p" :applet="page.applet" :judge="judgeResult" :serverImg="kHttpCode"
          v-else-if="p.key == 14"></XWResult>
        <div v-else-if="p.key == 7" :key="'7-' + key" class="source">
          <div class="left" v-if="p.value == 1 || p.value == 3">
            <h2>产品图</h2>
            <br />
            <img :style="{ width: p.value < 3 ? '50%' : '100%' }" :src="page.applet.productImgUrl" alt="" />
          </div>
          <div class="right" v-if="p.value == 2 || p.value == 3">
            <h2>手机拍摄图</h2>
            <br />
            <img :style="{ width: p.value < 3 ? '50%' : '100%' }" :src="result.fullPath.includes('http://')
              ? result.fullPath
              : 'http://47.95.37.145:8888' + result.fullPath
              " alt="" />
          </div>
        </div>
        <div :key="'8-' + key" v-else-if="p.key == 8" style="text-align: center">
          <img :src="kHttpCode.codeImageUrl" :style="{ width: p.value + '%' }" alt="" />
        </div>
        <div :key="'9-' + key" v-else-if="p.key == 9" style="text-align: center">
          <fieldset>
            <legend>真品存档图案</legend>

            <div style="font-size: 14px; line-height: 24px">
              <span>只需选择1个方格图案核对即可</span><br />
              <span>点击下图放大</span>
            </div>
            <img @click="imgView(kHttpCode.certificateImageUrl)" :src="kHttpCode.certificateImageUrl"
              :style="{ width: p.value + '%' }" alt="" />
          </fieldset>
        </div>
        <div style="text-align: center" v-else-if="p.key == 10 && page.applet.judgeModel != 1" :key="'10-' + key">
          <ScanQR :config="p" :appletId="page.applet.appletId" />
        </div>
        <div style="text-align: center; margin-bottom: 80px" v-else-if="p.key == 12" :key="'12-' + key">
          <div class="group-scan" @click="scanCodeGroup">扫码关联</div>
        </div>
        <div v-else-if="p.key == 13" :key="'12-' + key" style="display: flex; padding: 3px">
          <div v-for="img in p.images" style="padding: 3px; flex: 1">
            <a :href="img.name">
              <img :src="img.url" alt="" width="100%" />
            </a>
          </div>
        </div>
        <Tip v-else-if="p.key == 15" :resultType="resultType"></Tip>
      </template>
    </div>
    <FooterBtn v-if="page.buttons" :btns="page.buttons" :page="page"></FooterBtn>
  </div>
</template>

<script>
import { getH5Pages } from '@/api/h5Pages'
import { listKHttpCode } from '@/api/kHttpCode'
import Photograph from '@/components/Photograph'
import Result from '@/components/Result'
import XWResult from '@/components/Result/xw'
import Main from '@/components/example02/mainxw'
import ScanQR from '@/components/scanQR'
import Tip from '@/components/Result/tip'
import FooterBtn from './components/footerBtn.vue'

export default {
  components: {
    Photograph,
    Result,
    XWResult,
    Main,
    FooterBtn,
    ScanQR,
    Tip
  },
  data() {
    return {
      page: { buttons: [] },
      result: {},
      kHttpCode: {},
      judgeResult: 'xxxx',
      resultType: -1
    }
  },
  created() {
    this.init()

  },
  mounted() {
    setTimeout(() => {
      document.querySelectorAll("video").forEach(ele => {
        // console.log(ele)
        ele.volume = 0.2
      })
    }, 500)
  },
  watch: {
    '$route.query.pageId': function (value1, value2) {
      this.init()
    },
    '$store.state.applet.judgeResult': function (value1, value2) {
      // console.log(value1, value2)
      this.resultType = value1 == '相符' ? 0 : value1 == '不相符' ? 1 : value1 == '扫描图片模糊' ? 2 : value1 == '后台服务暂停' ? 3 : value1 == '无响应' ? 5 : -1
      this.judgeResult = value1
    }
  },
  methods: {

    scanCodeGroup() {
      this.$router.push({ path: '/codeGroup', query: { pageId: this.$route.query.pageId } })
    },
    imgView(imgUrl) {
      imgUrl = imgUrl.includes('http') ? imgUrl : location.origin + imgUrl
      WeixinJSBridge.invoke("imagePreview", { current: imgUrl, urls: [imgUrl] });
    },
    tipOff() {
      this.$router.push({ path: '/tip', query: { appletId: this.page.applet.appletId } })
    },
    init() {
      if (this.$route.query.url) {
        listKHttpCode({ pageNum: 1, pageSize: 1, http: this.$route.query.url }).then(res => {
          this.kHttpCode = res.rows.length > 0 ? res.rows[0] : {}
          this.kHttpCode.certificateImageUrl = this.kHttpCode.certificateImageUrl.replaceAll('http://doc.ksy7.cn', 'https://www.ksy7.cn').replaceAll('https://www.ksy7.cn', 'https://y3wm.cn')
          // console.log(JSON.stringify(this.kHttpCode))
        })
      }
      if (this.$route.query.key) {
        this.result = JSON.parse(sessionStorage.getItem("KSY_RESULT_" + this.$route.query.key))
        // console.log(this.result)
      }
      getH5Pages(this.$route.query.pageId).then(res => {
        document.title = res.data.applet.name
        res.data.links = JSON.parse(res.data.links)
        res.data.buttons = res.data.buttons.indexOf('[{') >= 0 ? JSON.parse(res.data.buttons) : res.data.buttons.split(',').map(item => {
          return { value: item, url: item == 4 ? this.form.remark : '' }
        })//res.data.buttons ? res.data.buttons.split(',') : []
        this.page = res.data
        if (this.page.pageType == 2 || this.page.pageType == 6) {
          this.result = JSON.parse(sessionStorage.getItem("KSY_RESULT_" + this.$route.query.key))

          listKHttpCode({ pageNum: 1, pageSize: 1, http: this.result.qr }).then(res => {
            this.kHttpCode = res.rows[0]
          })
        }

      })
    },
    goTo(pageId) {
      this.$router.push({ path: '/main', query: { pageId: pageId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding-top: 0.32rem;
  //margin-bottom: 1rem;
  box-sizing: border-box;

  .body {
    margin-top: 0.32rem;
  }
}

h1 {
  text-align: center;
  font-size: 0.56rem;
  padding: 0.32rem;
}

p {
  font-size: 0.44rem;
  line-height: 0.6rem;
  margin-bottom: 0.32rem;
}

.link {
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
  position: relative;
  height: 1rem;

  .back {
    position: absolute;
    height: 1rem;
    left: 0%;
    display: inline-block;
    z-index: 1;
    text-align: center;
    width: 100%;

    .font-back-color {
      padding: 0px 10px;
      background: #eeefef;

      a {
        // border-bottom: 1px solid #409eff;
      }
    }
  }
}

a {
  text-decoration: none;
  color: #409eff;
}

.source {
  display: flex;

  .left,
  .right {
    flex: 1;
    padding: 0.32rem;
    text-align: center;

    h2 {
      color: #515152;
      font-size: 0.32rem;
    }

    img {
      height: calc(100% - 40px);
    }
  }

  img {
    width: 100%;
  }
}

.footer {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 0.4rem;
  color: #409eff;

  div {
    flex: 1;
    text-align: center;
    background: #fff;
  }
}

fieldset {
  border: 3px solid #525151bf;
  border-radius: 10px;
  margin: 0 16px;

  legend {
    font-size: 16px;
    margin-bottom: 10px;
  }
}

.group-scan {
  margin: 0 auto;
  background: #126fb8;
  padding: 0.2rem;
  color: #fff;
  width: 1.6rem;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/pages/main/index.vue